document.body.addEventListener('click', function (event)
{
   const target = event.target;
   const selector = '.line-item--qty-button--decrease';
   const el = target.matches(selector) ? target : target.closest(selector) ? target.closest(selector) : null;
   if (el)
   {
      const inputElement = el.nextElementSibling;
      if (inputElement.classList.contains('quantity-input'))
      {
         inputElement.stepDown();
         inputElement.dispatchEvent(new Event("change", { bubbles: true }));
      }
   }
});

document.body.addEventListener('click', function (event)
{
   const target = event.target;
   const selector = '.line-item--qty-button--increase';
   const el = target.matches(selector) ? target : target.closest(selector) ? target.closest(selector) : null;
   if (el)
   {
      const inputElement = el.previousElementSibling;
      if (inputElement.classList.contains('quantity-input'))
      {
         inputElement.stepUp();
         inputElement.dispatchEvent(new Event("change", { bubbles: true }));
      }
   }
});